<form [formGroup]="primerGrupo" autocomplete="off" style="padding-top: 10px">
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="faseDeteccionCtrl"
          selected="selected"
          placeholder="Fase de detección"
        >
          <mat-option *ngFor="let item of faseDeteccion$ | async" [value]="item.id_fase">
            {{ item.nombre_faseDeteccion }}
          </mat-option>
        </mat-select>
        <mat-label>Fase de Detección</mat-label>
      </mat-form-field>
    </div>
    <div class="col-sm-6">
      <mat-form-field appearance="outline">
        <textarea
          aria-label="Descripción del Riesgo"
          formControlName="descripcionCtrl"
          matInput
          maxlength="240"
          rows="4"
          cols="80"
        ></textarea>
        <mat-label> Descripción del Riesgo</mat-label>
      </mat-form-field>
    </div>
    <div class="col-sm-6">
      <mat-form-field appearance="outline">
        <textarea
          aria-label="Causa Raíz"
          formControlName="causaRaizCtrl"
          matInput
          maxlength="240"
          rows="4"
          cols="80"
        ></textarea>
        <mat-label>Causa Raíz</mat-label>
      </mat-form-field>
    </div>
  </div>

  <div class="row justify-content-end">
    <button
      mat-button
      matStepperNext
      [disabled]="primerGrupo.invalid"
      class="btn btn-info"
    >
      Siguiente<i class="material-icons"> arrow_forward_ios </i>
    </button>
  </div>
</form>
